export const PERSONAL_LOAN_HEADER_TEXT = 'Get matched with prequalified loan options in 2 minutes.'
